import { Card } from '../models/card';

export function cardSummary(card: Card): string {
    const parts = [];
    if (card.attn) {
        parts.push(card.attn);
    }
    if (card.organization) {
        parts.push(card.organization);
    }
    if (card.city) {
        parts.push(card.city);
    }
    if (card.province) {
        parts.push(card.province);
    }
    if (card.postalCode) {
        parts.push(card.postalCode);
    }
    if (card.country) {
        parts.push(card.country);
    }
    return parts.join(', ');
}
